export class CheckRestoreCodeRequest {
    restoreCode: string;

    constructor(restoreCode: string){
        this.restoreCode = restoreCode;
    }
}